import React from 'react';
import { Navigate } from 'react-router-dom';
import PropertyInfo from '../pages/property-info';
import AddNewPropertyInfo from '../pages/add-new-property';
import WorkOrderInfo from '../pages/work-order-info';
import WorkOrderListing from '../pages/work-order-listing';
import ServiceCategory from '../pages/service-category';
import UploadMedia from '../pages/upload-media';
import Description from '../pages/description';
import WorkOrderSuccess from '../pages/work-order-success';
import AddAvailability from '../pages/add-availability';
import AddPropertyAccessDetails from '../pages/property-access-details';
import PortalLayout from '../layout/portal';

const allRoutes = [
  {
    path: '/',
    element: <PortalLayout />,
    children: [
      {
        index: true,
        element: <Navigate to="/work-order-info" />,
        key: 'index',
      },
      {
        path: 'work-order-info',
        element: <WorkOrderInfo />,
        key: 'work-order-info',
      },
      {
        path: '/property-info',
        element: <PropertyInfo />,
        key: 'property-info',
      },
      {
        path: '/add-new-property',
        element: <AddNewPropertyInfo />,
        key: 'add-new-property',
      },
      {
        path: 'work-order-listing',
        element: <WorkOrderListing />,
        key: 'work-order-listing',
      },
      {
        path: 'service-category',
        element: <ServiceCategory />,
        key: 'service-category',
      },
      {
        path: 'property-access-details',
        element: <AddPropertyAccessDetails />,
        key: 'property-access-details',
      },
      {
        path: 'upload-media',
        element: <UploadMedia />,
        key: 'upload-media',
      },
      {
        path: 'availability',
        element: <AddAvailability />,
        key: 'availability',
      },
      {
        path: 'description',
        element: <Description />,
        key: 'description',
      },
      {
        path: 'success',
        element: <WorkOrderSuccess />,
        key: 'success',
      },
    ],
  },
];

export default allRoutes;
